import MuiButtonBase, {
  type ButtonBaseProps as MuiButtonBaseProps,
} from '@mui/material/ButtonBase';
import { forwardRef } from 'react';

export type ButtonBaseProps = Pick<
  MuiButtonBaseProps,
  'children' | 'onClick' | 'disabled' | 'sx' | 'ref' | 'rel' | 'disableRipple'
> & {
  href?: string | null;
  target?: string;
};

export const ButtonBase = forwardRef<HTMLButtonElement, ButtonBaseProps>(
  ({ children, ...props }, ref) => (
    <MuiButtonBase {...props} ref={ref}>
      {children}
    </MuiButtonBase>
  ),
);
